import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_WASTE_DATA: '/GetWasteData',
  GET_WASTE_DATA_EXCEL: '/GetWasteDataExcel',
  GET_SEPARATED_WASTE_DATA: '/GetSeparatedWasteStatisticsData',
  GET_SEPARATED_WASTE_DATA_EXCEL: '/GetSeparatedWasteDataExcel'
};

export const getWasteData = async (params = {}) => {
  const { offset = 0, address = '', days, search = '' } = params;
  
  // Replace spaces with %20 in address and search
  const encodedAddress = address.replace(/ /g, '%20');
  const encodedSearch = search.replace(/ /g, '%20');

  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTE_DATA}?offset=${offset}`;
  
  if (encodedAddress) url += `&adress=${encodedAddress}`;
  if (days !== undefined && days !== '') url += `&days=${days}`;
  if (encodedSearch) url += `&search=${encodedSearch}`;

  const response = await fetch(url, {
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch waste data');
  }

  return response.json();
};

export const getWasteDataExcel = async (days) => {
  try {
    let url;
    if (days === 0) {
      url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTE_DATA_EXCEL}?days=0`;
    } else {
      url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_WASTE_DATA_EXCEL}${days ? `?days=${days}` : ''}`;
    }
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Excel indirme işlemi başarısız oldu');
    }

    // Get the filename from the content-disposition header
    const contentDisposition = response.headers.get('content-disposition');
    const filenameMatch = contentDisposition && contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    // Get current date for filename
    const today = new Date();
    const date = today.toISOString().split('T')[0];
    const filename = filenameMatch && filenameMatch[1] ? filenameMatch[1].replace(/['"]/g, '') : `Atik_Verileri_${date}.xlsx`;

    // Convert response to blob
    const blob = await response.blob();
    
    // Create a download link and trigger it
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error('Excel download error:', error);
    throw error;
  }
};

export const getSeparatedWasteData = async (params = {}) => {
  const { offset = 0, address = '', days, search = '' } = params;
  
  // Replace spaces with %20 in address and search
  const encodedAddress = address.replace(/ /g, '%20');
  const encodedSearch = search.replace(/ /g, '%20');

  let url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_SEPARATED_WASTE_DATA}?offset=${offset}`;
  
  if (encodedAddress) url += `&adress=${encodedAddress}`;
  if (days !== undefined && days !== '') url += `&days=${days}`;
  if (encodedSearch) url += `&search=${encodedSearch}`;

  const response = await fetch(url, {
    headers: {
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch separated waste data');
  }

  return response.json();
};

export const getSeparatedWasteDataExcel = async (days) => {
  try {
    let url;
    if (days === 0) {
      url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_SEPARATED_WASTE_DATA_EXCEL}?days=0`;
    } else {
      url = `${axiosInstance.defaults.baseURL}${ENDPOINTS.GET_SEPARATED_WASTE_DATA_EXCEL}${days ? `?days=${days}` : ''}`;
    }
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Excel indirme işlemi başarısız oldu');
    }

    // Get the filename from the content-disposition header
    const contentDisposition = response.headers.get('content-disposition');
    const filenameMatch = contentDisposition && contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    // Get current date for filename
    const today = new Date();
    const date = today.toISOString().split('T')[0];
    const filename = filenameMatch && filenameMatch[1] ? filenameMatch[1].replace(/['"]/g, '') : `Ayristirilmis_Atik_Verileri_${date}.xlsx`;

    // Convert response to blob
    const blob = await response.blob();
    
    // Create a download link and trigger it
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error('Excel download error:', error);
    throw error;
  }
}; 